import { Injectable, signal } from "@angular/core";

export type DisplayMode = "TIME-WISE" | "LEAGUE-WISE";

@Injectable({
  providedIn: "root",
})
export class DisplayModeService {
  private readonly STORAGE_KEY = "market_display_mode";
  private modeSignal = signal<DisplayMode>(this.getInitialMode());

  readonly mode = this.modeSignal.asReadonly();

  constructor() {}

  private getInitialMode(): DisplayMode {
    const savedMode = localStorage.getItem(this.STORAGE_KEY);
    return (savedMode as DisplayMode) || "LEAGUE-WISE";
  }

  setMode(mode: DisplayMode) {
    localStorage.setItem(this.STORAGE_KEY, mode);
    this.modeSignal.set(mode);
  }

  isMode(mode: DisplayMode): boolean {
    return this.modeSignal() === mode;
  }
}
